import { IBadgeProps } from './Badge.types'
import * as S from './Badge.styles'

export const Badge = ({ children, variant = 'default', size = 'medium', className }: IBadgeProps) => {
    return (
        <S.BadgeContainer $variant={variant} $size={size} className={className}>
            {children}
        </S.BadgeContainer>
    )
}
